import * as types from './dashboardTypes';
import { getRequest, postRequest } from '../../globalhelper/helper';
import moment from 'moment';

export const setDashboardLoading = (isLoading) => ({
    type: types.SET_DASHBOARD_LOADING,
    payload: isLoading,
});

export const fetchCompanies = () => async (dispatch) => {
    try {
        const response = await getRequest(`api/edureka/getCompanyAssignedToUser`);
        const responseData = response.res.data || [];
        dispatch({ type: types.SET_COMPANIES, payload: responseData });
        return responseData;
    } catch (err) {
        console.error(err);
        dispatch({ type: types.SET_DASHBOARD_ERROR, payload: err.message });
    }
};

export const setInboxData = (data) => ({
    type: types.SET_INBOX_DATA,
    payload: data,
});

export const setProjectData = (data) => ({
    type: types.SET_PROJECT_DATA,
    payload: data,
});

export const setExpenseData = (data) => ({
    type: types.SET_EXPENSE_DATA,
    payload: data,
});

export const setDocumentsData = (data) => ({
    type: types.SET_DOCUMENTS_DATA,
    payload: data,
});

export const setSummaryStats = (stats) => ({
    type: types.SET_SUMMARY_STATS,
    payload: stats,
});
